import { render, staticRenderFns } from "./Customers5.vue?vue&type=template&id=efbe6ad4&"
import script from "./Customers5.vue?vue&type=script&lang=js&"
export * from "./Customers5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports